module.exports = __webpack_public_path__ + "static/media/SourceSans-Bold.6d996a0e.woff";